if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.stickyAtc = this.closest('sticky-atc');
      this.formInput = this.querySelector('input[name="quantity"]');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (this.formInput) {
        this.formInput.addEventListener('change', this.onChangeHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.quantityInput = this.form.querySelector('[data-input-quantity]');
      this.quantityErrorMessage = this.form.querySelector('[data-add-to-cart-error]');

      this.maxOrder = parseInt(this.querySelector('[data-max-order]').value);
      const currentAmount = parseInt(this.querySelector('[data-cart-quantity]').value);
      const maxOrderAmount = this.maxOrder - currentAmount;
      this.InputVal = parseInt(this.formInput.value);
      this.QuantityPlus = this.form.querySelector('button[name="plus"]');
      const maxError = this.querySelector('[data-max-error]');

      if (this.InputVal >= this.maxOrder || this.InputVal >= maxOrderAmount) {
        if (maxError){
          this.formInput.setAttribute('readonly', true);
        }
        if (this.QuantityPlus) {
          this.QuantityPlus.classList.add('disabled');
        }
      }
    }

    onChangeHandler(evt) {
      this.maxOrder = parseInt(this.querySelector('[data-max-order]').value);
      this.InputVal = parseInt(this.formInput.value);
      const currentAmount = parseInt(this.querySelector('[data-cart-quantity]').value);
      const maxOrderAmount = this.maxOrder - currentAmount;
      this.QuantityPlus = this.form.querySelector('button[name="plus"]');
      const maxError = this.querySelector('[data-max-error]');
      if (this.InputVal >= this.maxOrder || this.InputVal >= maxOrderAmount) {
        if (maxError){
          maxError.classList.remove('hidden');
          this.formInput.setAttribute('readonly', true);
          this.formInput.value = maxOrderAmount;

        }
        if (this.QuantityPlus) {
          this.QuantityPlus.classList.add('disabled');
        }
      } else {
        if (maxError){
          maxError.classList.add('hidden');
        }
        if (this.QuantityPlus) {
          this.QuantityPlus.classList.remove('disabled');
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      // if sticky atc is enabled and sticky atc is sticky and product has recharge subscription widget, scroll to recharge subscription widget before able to add to cart
      const rechargeWidget = document.querySelector('.recharge-subscription-widget .rc-widget');
      if (rechargeWidget && rechargeWidget !== null && rechargeWidget !== undefined && this.stickyAtc && this.stickyAtc.classList.contains('is-sticky')) {
          const header = document.querySelector('.header');
          const yOffset = -header.offsetHeight;
          const y = rechargeWidget.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});

      } else {

        const submitButton = this.querySelector('[type="submit"]');
        const maxOrderError = this.querySelector('[data-max-order-error]');
        this.currentAmountElm = this.querySelector('[data-cart-quantity]');
        let currentAmount = parseInt(this.querySelector('[data-cart-quantity]').value);
        this.maxOrder = parseInt(this.querySelector('[data-max-order]').value);
        this.InputVal = parseInt(this.formInput.value);
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const sectionsToFetch = [
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
          ...this.cartNotification.getSectionsToRender().map((section) => section.id)
        ];

        const formData = new FormData(this.form);
        formData.append('sections', sectionsToFetch);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        // Check cart items before adding
        const productId = parseInt(this.querySelector('[data-productid]').dataset.productid);
        const productMaxOrder = parseInt(this.querySelector('[data-max-order]').value);
        let stillAbleToAdd = true;

        fetch(`${routes.cart_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            const cartItems = response.items;
            cartItems.filter(function(item, index) {

              if (item.product_id === productId) {
                const productFromTheCart = cartItems[index];
                // check cart item quantity v.s. max order quantity
                if (productFromTheCart.quantity >= productMaxOrder) {
                  stillAbleToAdd = false;
                  submitButton.setAttribute('disabled', true);
                }
              }
            })
          });

        setTimeout(() => {
          if (stillAbleToAdd) {
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((parsedState) => {
                if (parsedState.status == 422) {
                  // When quantity error unsuficient inventory
                  this.cartNotification.setActiveElement(document.activeElement);
                  this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
                  return;
                }
                this.cartDrawer.renderContents(parsedState);
                switch (submitButton.dataset.addToCartBehavior) {
                  case ('open_cart_drawer'):
                    this.cartDrawer.open();
                    break;
                  case ('show_cart_notification'):
                  default:
                    this.cartNotification.setActiveElement(document.activeElement);
                    this.cartNotification.renderContents(parsedState);
                }
                const QuickshopPopup = document.querySelectorAll('[data-quickshop-popup]');
                const QuickshopIsOpenClass = 'quickshop__popup--is-open';
                if (QuickshopPopup) {
                  QuickshopPopup.forEach((popup) => {
                    popup.classList.remove(QuickshopIsOpenClass);
                  });
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('disabled');
                let newCurrentAmount = parseInt(currentAmount) + parseInt(this.InputVal);
                if (this.InputVal >= this.maxOrder || currentAmount >= this.maxOrder || newCurrentAmount >= this.maxOrder) {
                  if (maxOrderError){
                    maxOrderError.classList.remove('hidden');
                    submitButton.setAttribute('disabled', true);
                  }
                  submitButton.setAttribute('disabled', true);
                } else {
                  if (maxOrderError){
                    maxOrderError.classList.add('hidden');
                    submitButton.setAttribute('disabled', true);
                  }
                  submitButton.removeAttribute('disabled');
                }
                this.currentAmountElm.setAttribute('value', newCurrentAmount);
              });
          } else {
            //remove the loading class from he add to cart button
            submitButton.classList.remove('loading');
            const productMaxOrder = parseInt(this.querySelector('[data-max-order]').value);
            this.cartNotification.renderQuantityError(productMaxOrder);
            return
          }
        }, 1000);
      }
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}